<div class="container">
  <h1 style="display:flex;align-items: center;">
    <span style="cursor: default">My Dashboard</span><div style="font-weight:500;font-size:16px;color:#b71717;padding-left:24px;">
    <div style="cursor:default;display: flex;align-items: center"><mat-icon style="margin-top:4px;">palette</mat-icon>
    Design Mockup</div></div>
    <div style="flex:1;flex-grow: 3"></div>
    <mat-form-field appearance="outline" style="font-size:initial;width:250px">
      <mat-label>Selected Report</mat-label>
      <mat-select [(value)]="selectedReport" autofocus>
        <mat-option *ngFor="let report of reports" [value]="report.value">
          {{ report.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </h1>

  <hr>

  <ng-container *ngIf="selectedReport==='generalReport'">
    <app-report-day-selector (dateChanged)="dateChanged($event)"></app-report-day-selector>

    <div style="margin-bottom:24px;display:flex;gap:24px;flex-wrap: wrap;">
      <mat-button-toggle-group
        [(ngModel)]="selectedDataset"
        (change)="updateMockData()"
        aria-label="Chart Data">
        <mat-button-toggle value="sold">Vehicles Sold</mat-button-toggle>
        <mat-button-toggle value="visits">Visits</mat-button-toggle>
        <mat-button-toggle value="g">G</mat-button-toggle>
        <mat-button-toggle value="f">F</mat-button-toggle>
        <mat-button-toggle value="a">A</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-button-toggle-group
        name="chartType"
        [(ngModel)]="lineChartType"
        aria-label="Chart Type">
        <mat-button-toggle value="bar">Bar Graph</mat-button-toggle>
        <mat-button-toggle value="line">Line Graph</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-button-toggle-group
        name="chartType"
        [(ngModel)]="lineChartDuration"
        (change)="updateMockData()"
        aria-label="Chart Type">
        <mat-button-toggle [value]="30">30 Days</mat-button-toggle>
        <mat-button-toggle [value]="90">90 Days</mat-button-toggle>
        <mat-button-toggle [value]="180">180 Days</mat-button-toggle>
        <mat-button-toggle [value]="360">360 Days</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <h2>{{ lineChartDuration }} day summary prior to {{ (reportDate | date:'fullDate') }}</h2>

    <div class="chart-container">
      <canvas baseChart
              [type]="lineChartType"
              [data]="lineChartData"
              [options]="lineChartOptions">
      </canvas>
    </div>

    <mat-tab-group animationDuration="0" (click)="$event.stopPropagation();$event.preventDefault()"
                   style='min-height:800px'>
      <mat-tab label="Daily Stats" (click)="$event.stopPropagation();$event.preventDefault()">
        <h2 style="margin-top:0;padding-top:16px;">Daily stats for {{ reportDate | date:'fullDate' }}</h2>
        <div
          style="display:flex;justify-content: stretch; align-items: flex-start;gap:24px;width:100%;margin-top:12px;">
          <app-vehicle-sold-table-summary></app-vehicle-sold-table-summary>
          <app-vehicle-sold-table></app-vehicle-sold-table>
        </div>
      </mat-tab>
      <mat-tab label="More Stats" (click)="$event.stopPropagation();$event.preventDefault()">
        <h2 style="margin-top:0;padding-top:16px;">More stats for {{ reportDate | date:'fullDate' }}</h2>
      </mat-tab>
      <mat-tab label="Call Volume" (click)="$event.stopPropagation();$event.preventDefault()">
        <h2 style="margin-top:0;padding-top:16px;">Call Volume for {{ reportDate | date:'fullDate' }} </h2>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>
